export default __webpack_public_path__ + "static/media/illustration-health-1-w@2x.14eae3a5.webp";